export function tsOmit<T extends Record<string, any>, U extends keyof T>(
  obj: T,
  keys: U[]
): Omit<T, U> {
  return (Object.keys(obj) as U[]).reduce(
    (acc, curr) => (keys.includes(curr) ? acc : { ...acc, [curr]: obj[curr] }),
    {} as Omit<T, U>
  );
}
